import { render } from "./RadioButton.vue?vue&type=template&id=4accd6fb"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"

import "./RadioButton.vue?vue&type=style&index=0&id=4accd6fb&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__